'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('../../../src/stylus/components/_grid.styl');

var _grid = require('./grid');

var _grid2 = _interopRequireDefault(_grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _grid2.default)('layout');
//# sourceMappingURL=VLayout.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VGrid/VLayout.js
// module id = 507
// module chunks = 0